<mat-expansion-panel
  hideToggle
  class="status-section"
  [disabled]="isDisabled"
  >
  <mat-expansion-panel-header
    class="accordion-header"
    >
    <mat-panel-title class="section-heading">
      <div
        class="stepper-block first"
        [class.disabled]="isDisabled"
        >
        <div class="stepper-circle"></div>
        <div class="stepper-line"></div>
      </div>
      <div class="header">
        <div class="line-1">
          <div class="block-heading">REQUEST</div>
          <div class="section-heading">{{ subheading }}</div>
        </div>
        <mat-icon
          class="line-2 chevron-icon"
          [svgIcon]="isExpanded ? 'chevron-up' : 'chevron-down'"
          />
      </div>

    </mat-panel-title>
  </mat-expansion-panel-header>
  <div
    class="content-section"
    [class.disabled]="isDisabled"
    >
    <section class="section">
      <div class="section-heading">CREATED BY:</div>
      <div class="section-content">
        {{ activity?.sent_to_lab?.createdBy?.name }}
      </div>
    </section>
    <section class="section">
      <div class="section-heading">CREATED ON:</div>
      <div class="section-content">
        {{ activity?.sent_to_lab?.created_at | dateFormat: 'very-long' }}
      </div>
    </section>
    <section class="section">
      <div class="section-heading">TEST NAME:</div>
      <div class="section-content">
        {{ data?.material_test?.name }}
      </div>
    </section>
    <section class="section">
      <div class="section-heading">LAB NAME:</div>
      <div class="section-content">
        {{ data?.lab?.name }}
      </div>
    </section>
    <section class="section">
      <div class="section-heading">DATE & TIME:</div>
      <div class="section-content">
        {{ data?.request_date | dateFormat: 'long' }}
      </div>
    </section>
    @if (data?.pictures?.length) {
      <section class="section">
        <app-attachments-block
          [pictures]="data?.pictures"
          />
      </section>
    }
    @if (data?.comment) {
      <section class="section">
        <div class="section-heading">COMMENT:</div>
        <div class="section-content">
          {{ data?.comment }}
        </div>
      </section>
    }
  </div>
</mat-expansion-panel>
